import { FC } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureOverlayBanner, IOverlayBanner } from 'mod/featureV2/interface/overlayBanner';
import { FeatureBanner } from 'mod/featureV2/FeatureBanner';
import { Banner } from 'mod/featureV2/Banner';
import { HtmlRender } from '@base/snippets/HtmlRender';
import { forceVideoAsGif } from 'mod/featureV2/Banner/utils';
import { Button } from '@base/lib/Button';
import Link from '@base/lib/Link';

export type IProps = IFeatureProps<IFeatureOverlayBanner>;

export const FeatureTextBanner: FC<IProps> = props => {
    const {
        feature,
        ...rest
    } = props;

    return (
        <FeatureBanner<IOverlayBanner>
            {...rest}
            feature={feature}
            renderBanner={bannerProps => {
                const { banner, ...rest } = bannerProps;
                const noText = !banner.subtitle && !banner.title && !banner.description && !banner.button;

                if (noText) {
                    return (
                        <div className={'g-banner-wrap'}>
                            <div className={'g-media'}>
                                <Banner {...rest} banner={banner}/>
                            </div>
                        </div>
                    );
                }

                return (
                    <Link
                        href={banner.href}
                        hrefEmptyTag={'div'}
                        className={'g-banner-wrap'}
                    >
                        <div className={'g-media'}>
                            <Banner
                                {...rest}
                                banner={{
                                    ...forceVideoAsGif(banner),
                                    href: void 0
                                }}
                            />
                        </div>

                        <div className={'g-text'}>
                            <HtmlRender className={'g-subtitle'} html={banner.subtitle}/>
                            <HtmlRender className={'g-title'} html={banner.title}/>
                            <HtmlRender className={'g-desc'} html={banner.description}/>

                            {banner?.button && (
                                <Button
                                    className={'g-button'}
                                    {...banner.button}
                                />
                            )}
                        </div>
                    </Link>
                )
            }}
        />
    )
};